// src/pages/DownloadApp.jsx
import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaApple, FaGooglePlay, FaQrcode, FaMobileAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AppDownloadSection.css";
import appImage from "../../assets/images/appImage.png";
import qrCodeAppStore from "../../assets/images/qrCodeAppStore.jpg";
import qrCodeGooglePlay from "../../assets/images/qrCodeGooglePlay.jpg";
import { TiVendorAndroid } from "react-icons/ti";

export default function AppDownloadSection() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>

      <section className="download-app-section">
        <Container>
          <Row className="download-card align-items-center">
            {/* Left Content */}
            <Col lg={12} data-aos="fade-right">
              <div className="download-content">

                <Row className="align-items-center">
                  <Col lg={9}>
                    <div className="d-flex align-items-center gap-4">
                      <FaMobileAlt className="qr-icon" />
                      <div>
                        <h1 className="download-title">
                          {t("downloadApp.title1", "TransCiroX")} <span className="text-orange">{t("downloadApp.title2", "App")}</span> {t("downloadApp.title3", "herunterladen")}
                        </h1>
                        <p className="download-subtitle">
                          {t(
                            "downloadApp.subtitle",
                            "Transportaufträge direkt auf deinem Smartphone."
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="download-buttons mt-4">
                      <Button
                        className="download-btn google-play"
                        href="https://apps.apple.com/us/app/transcirox/id6795202213"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaApple className="btn-icon" />
                        <div className="btn-text">
                          <span className="btn-small">
                            {t("downloadApp.loadIn", "Laden im")}
                          </span>
                          <span className="btn-large">App Store</span>
                        </div>
                      </Button>

                      <Button
                        className="download-btn google-play"
                        href="https://play.google.com/store/apps/details?id=com.transcairo.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaGooglePlay className="btn-icon" />
                        <div className="btn-text">
                          <span className="btn-small">
                            {t("downloadApp.jetztBei", "JETZT BEI")}
                          </span>
                          <span className="btn-large">Google Play</span>
                        </div>
                      </Button>
                    </div>
                  </Col>

                  <Col lg={3}>
                    <img src={appImage} width={200} className="app-image" alt="app_image" />
                  </Col>
                </Row>

                <div className="qr-section mt-5">

                  <div className="qr-divider">
                    <span className="qr-divider-line"></span>
                    <p className="qr-label">
                      {t("downloadApp.orScanQR", "oder QR-Code scannen")}
                    </p>
                    <span className="qr-divider-line"></span>
                  </div>

                  <Row className="qr-codes g-4">
                    <Col lg={6}>
                      <a
                        className="text-decoration-none"
                        href="https://apps.apple.com/us/app/transcirox/id6795202213"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="qr-card">
                          <div className="qr-image-wrapper">
                            <img
                              src={qrCodeAppStore}
                              alt={t("downloadApp.qrAppStore", "App Store QR Code")}
                              className="qr-image"
                              loading="lazy"
                            />
                          </div>
                          <div className="text-start">
                            <div className="qr-label-text d-flex align-items-center gap-2">
                              <FaApple className="qr-label-icon"/>
                              <span className="text-dark">{t("downloadApp.iphone", "iPhone")}</span>
                            </div>
                            <p className="qr-description">
                              {t(
                                "downloadApp.scanAppStore",
                                "Scanne den QR-Code für den"
                              )}
                              &nbsp;
                              <span className="text-orange fw-bold">App Store</span>
                            </p>
                          </div>
                        </div>
                      </a> 
                    </Col>
                    <Col lg={6}>
                      <a
                        className="text-decoration-none"
                        href="https://play.google.com/store/apps/details?id=com.transcairo.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="qr-card">
                          <div className="qr-image-wrapper">
                            <img
                              src={qrCodeGooglePlay}
                              alt={t("downloadApp.qrGooglePlay", "Google Play QR Code")}
                              className="qr-image"
                              loading="lazy"
                            />
                          </div>
                          <div className="text-start">
                            <div className="qr-label-text d-flex align-items-center gap-2">
                              <TiVendorAndroid className="qr-label-icon"/>
                              <span className="text-dark">{t("downloadApp.android", "Android")}</span>
                            </div>
                            <p className="qr-description">
                              {t(
                                "downloadApp.scanGooglePlay",
                                "Scanne den QR-Code für Google Play"
                              )}
                              &nbsp;
                              <span className="text-orange fw-bold">Google Play</span>
                            </p>
                          </div>
                        </div>
                      </a>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}